import React, { useCallback } from 'react'
import { useHideModal, useIsShowModal } from 'src/Modal/ModalStateContext'
import { ModalForm, ModalFormId } from 'src/components/ModalForms/ModalForm'
import {
  initialConfirmationState,
  useAlertDialogContext,
} from './AlertDialogContext'

export const AlertDialog = (): JSX.Element => {
  const { alertDialogState, setAlertDialogState } = useAlertDialogContext()
  const onClose = useCallback(() => {
    setAlertDialogState(initialConfirmationState)
  }, [setAlertDialogState])
  const show = useIsShowModal(ModalFormId.ALERT_DIALOG)
  const hide = useHideModal({
    modalId: ModalFormId.ALERT_DIALOG,
    onHide: onClose,
  })

  return (
    <ModalForm
      show={show}
      size={alertDialogState.size || 'sm'}
      hide={hide}
      formId={ModalFormId.ALERT_DIALOG}
      title={alertDialogState.title}
      description={alertDialogState.body}
      hideButtons
    ></ModalForm>
  )
}
